import { writable } from 'svelte/store'

export const stories = writable([])

export const configuration = writable({})

export const iframeURL = writable('https://tappable-sdk.web.app')

export const playerOpen = writable(false)

const allowList = ['localhost', '127.0.0.1']

const apiURL = `https://api.tappable.io/v1/stories`

if (window && window.location) {
  const { hostname, origin } = window.location
  if (allowList.includes(hostname)) iframeURL.set(origin)
}

export async function fetchStory(story, workspace) {
  try {
    if (!story || !workspace) return console.error('Add story id or workspace')

    const storyId = story.replace(/\/+$/, '')
    const res = await fetch(`${apiURL}/${workspace}/${storyId}`)
    return [await res.json()]
  } catch (e) {
    console.log(e)
    throw e
  }
}

export async function fetchStories(workspace) {
  try {
    if (!workspace) return false

    const res = await fetch(`${apiURL}/${workspace}`)
    return [...(await res.json().then((data) => data.stories))]
  } catch (e) {
    console.error(e)
    throw e
  }
}
